import React from 'react'
import LogoName from './logoicon.svg'
import LogoBlue from './logoicon_blue.svg'
import PropTypes from 'prop-types'

const LogoIcon = (props) => {
    switch (props.color) {
        case 'white':
            return <img src={LogoName} alt="Bougas Logo" width={props.width} />
        case 'blue':
            return <img src={LogoBlue} alt="Bougas Logo" width={props.width} />
        default:
            return <img src={LogoName} alt="Bougas Logo" width={props.width} />
    }
}

LogoIcon.defaultProps = {
    width: '200px',
    color: 'white',
}

LogoIcon.propTypes = {
    width: PropTypes.string,
    color: PropTypes.string,
}

export default LogoIcon
